import React from 'react';
import Loadable from 'components/Loadable';
import {PublicLayout} from 'components/Layouts';

import renderRoutes from 'pages/routes';

export default {
  exact: true,
  //auth: false,
  path: '/book',
  component: ({routes}) => {
    return <PublicLayout>{renderRoutes(routes)}</PublicLayout>;
  },
  routes: [
    {
      //exact: false,
      //auth: false,
      //path: '/book',
      component: Loadable({
        loader: () => import('./schedule2')
      })
    }
  ]
};


// WEBPACK FOOTER //
// ./src/pages/front/schedule.js